import { createContext, type Dispatch, type SetStateAction, useContext } from 'react';

import noop from '@atlaskit/ds-lib/noop';

export const IsOpenContext = createContext(false);
export const SetIsOpenContext = createContext<Dispatch<SetStateAction<boolean>>>(noop);
export const useToggleFlyoutMenuOpen = () => useContext(SetIsOpenContext);
